// extracted by mini-css-extract-plugin
export default {"container":"importance-card_container__EoY5m","heading":"importance-card_heading__RH4rr","message":"importance-card_message__83ebC"};